import { ReactElement } from 'react';

import { Footer } from '~/components/global';
import NavHeader from '~/components/navigation/NavHeader';
import { ScrollToTop } from '~/components/ui';
import usePrivy from '~/lib/script/privy';

export default function BaseLayout({
  children,
  className,
  isCartPage,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
  isCartPage?: boolean;
}) {
  const isCollectionBrowsePage = (children as ReactElement)?.props
    ?.isCollectionBrowsePage;

  usePrivy();

  const classNames = isCartPage
    ? 'pt-[121px] md:pt-[85px]'
    : `pt-[111px] md:pt-[131px]`;

  return (
    <div className={className} {...props}>
      <NavHeader
        isCollectionBrowsePage={isCollectionBrowsePage}
        isCartPage={isCartPage}
      />
      {/* Padding for fixed header */}
      <div id="headlessui-portal-root" className={classNames}>
        {children}
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
